<script>
import bem from '@/utils/bem';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import StatusTab from '@/pages/settings/statusesTab/Statuses-tab.vue';
import EmailsTab from '@/pages/settings/emailsTab/Emails-tab.vue';
import SmsTab from '@/pages/settings/smsBlockTab/Sms-tab.vue';
import MessagesTab from '@/pages/settings/messageTemplates/Messages-tab.vue';
import FaqTemplatesTab from '@/pages/settings/faqTemplatesTab/Faq-templates-tab.vue';
import HintTemplatesTab from '@/pages/settings/hintTemplateTab/Hint-template-tab.vue';

const OPTIONS = [
  {
    title: 'Statuses',
    key: 'statuses',
  },
  {
    title: 'Emails',
    key: 'emails',
  },
  {
    title: 'SMS Templates',
    key: 'sms',
  },
  {
    title: 'Messages Templates',
    key: 'messagesTemplates',
  },
  {
    title: 'FAQ Templates',
    key: 'faqTemplates',
  },
  {
    title: 'Help Centers Templates',
    key: 'helpCentersTemplates',
  },
];

const b = bem('settings-page');
export default {
  components: {
    FaqTemplatesTab,
    PageHeader,
    StatusTab,
    EmailsTab,
    SmsTab,
    MessagesTab,
    HintTemplatesTab,
  },
  data() {
    const option = OPTIONS.find((opt) => opt.key === this.$route.params.tab) || OPTIONS[0];
    return {
      title: option.title,
      options: OPTIONS,
      key: option.key,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
};
</script>

<template>
  <div :class="b()">
    <page-header :title="title"/>
    <status-tab v-if="key === 'statuses'"/>
    <emails-tab v-if="key === 'emails'"/>
    <sms-tab v-if="key === 'sms'"/>
    <messages-tab v-if="key === 'messagesTemplates'"/>
    <faq-templates-tab v-if="key === 'faqTemplates'"/>
    <hint-templates-tab v-if="key === 'helpCentersTemplates'"/>
  </div>
</template>

<style src="./style.scss" scoped lang="scss"></style>
